export const services: Record<string, string> = {
  // Shared formatting and generated report/export content
  '1 day remaining': '1 jour restant',
  'Access / Visitor Log': 'Registre des accès et visiteurs',
  'Access Summary': 'Synthèse des accès',
  'Action Taken': 'Mesure prise',
  'Actions Taken': 'Mesures prises',
  'Alarm Report': 'Rapport d’alarme',
  'Already on another duty at this time.': 'Déjà affecté à un autre service à cet horaire.',
  'Archived': 'Archivé',
  'Area Secured': 'Zone sécurisée',
  'Attachments ({count})': 'Pièces jointes ({count})',
  'CCTV / Access Logs Available': 'Vidéosurveillance / journaux d’accès disponibles',
  'CONFIDENTIAL': 'CONFIDENTIEL',
  'Check In': 'Prise de service',
  'Check Out': 'Fin de service',
  'Comments ({count})': 'Commentaires ({count})',
  'Completed': 'Terminé',
  'Completed Checkpoints': 'Points de contrôle effectués',
  'Confidential': 'Confidentiel',
  'Confidential Report': 'Rapport confidentiel',
  'Contractors': 'Prestataires',
  'Daily Activity Report': 'Rapport d’activité journalier',
  'Damage / Loss': 'Dommages / pertes',
  'Deliveries': 'Livraisons',
  'Departure': 'Départ',
  'Destination': 'Destination',
  'Direction': 'Sens',
  'Duty': 'Service',
  'Emergency Services Attended': 'Intervention des services d’urgence',
  'Entered': 'Entrées',
  'Event': 'Événement',
  'Evidence': 'Éléments de preuve',
  'Exited': 'Sorties',
  'Expired': 'Expiré',
  'Expired 1 day ago': 'Expiré il y a 1 jour',
  'Expired {count} days ago': 'Expiré il y a {count} jours',
  'Expires in {hours}h {minutes}m': 'Expire dans {hours} h {minutes} min',
  'Expires in {minutes}m': 'Expire dans {minutes} min',
  'Expires today': 'Expire aujourd’hui',
  'Expiry timing unavailable': 'Date d’expiration indisponible',
  'Exported from {company} portal on {date}':
    'Exporté depuis le portail {company} le {date}',
  'Exported: {date}': 'Exporté le : {date}',
  'External Reference': 'Référence externe',
  'Follow Up Required': 'Suivi requis',
  'Force Used': 'Force employée',
  'General Report': 'Rapport général',
  'Handover': 'Relève',
  'Handover To': 'Relève transmise à',
  'Impact / Risk': 'Impact / risque',
  'Incident Details': 'Détails de l’incident',
  'Incident Report': 'Rapport d’incident',
  'Incident Type': 'Type d’incident',
  'Injuries / Medical': 'Blessures / soins médicaux',
  'Internal Note': 'Note interne',
  'Intervention': 'Intervention',
  'Investigation Checks': 'Vérifications de l’enquête',
  'Invite cancelled': 'Invitation annulée',
  'Invite expired': 'Invitation expirée',
  'Invite pending': 'Invitation en attente',
  'Maintenance Details': 'Détails de la maintenance',
  'Maintenance Report': 'Rapport de maintenance',
  'Manager / Control Notified': 'Responsable / poste de contrôle informé',
  'Medical Offered': 'Soins médicaux proposés',
  'Missed Checkpoints': 'Points de contrôle manqués',
  'Name': 'Nom',
  'Narrative': 'Compte rendu',
  'Needs More Info': 'Informations complémentaires requises',
  'No': 'Non',
  'No map point': 'Aucun point sur la carte',
  'Not generated yet': 'Pas encore généré',
  'Notifications / References': 'Notifications / références',
  'Organisation': 'Organisation',
  'Outstanding Issues': 'Problèmes en suspens',
  'Page': 'Page',
  'Page {page} of {total}': 'Page {page} sur {total}',
  'Patrol Report': 'Rapport de ronde',
  'Patrol Summary': 'Synthèse de la ronde',
  'People Involved': 'Personnes impliquées',
  'Photo': 'Photo',
  'Photo attachment': 'Photo en pièce jointe',
  'Photo attachment (could not embed)': 'Photo en pièce jointe (intégration impossible)',
  'Police Notified': 'Police informée',
  'Post / Assignment': 'Poste / affectation',
  'Reason For Force': 'Motif du recours à la force',
  'Related Report': 'Rapport associé',
  'Report Content': 'Contenu du rapport',
  'Report ID': 'Identifiant du rapport',
  'Route': 'Itinéraire',
  'Rows': 'Lignes',
  'SECURITY REPORT': 'RAPPORT DE SÉCURITÉ',
  'Scanned': 'Scanné',
  'Scene Secured': 'Lieu sécurisé',
  'Security Report': 'Rapport de sécurité',
  'Select a site': 'Sélectionner un site',
  'Shift End': 'Fin de vacation',
  'Shift Execution': 'Exécution de la vacation',
  'Shift Start': 'Début de vacation',
  'Shift Summary': 'Synthèse de la vacation',
  'Source Summary': 'Synthèse de la source',
  'Staff': 'Personnel',
  'Started': 'Commencé',
  'Use of Force Details': 'Détails du recours à la force',
  'Use of Force Report': 'Rapport de recours à la force',
  'Video attachment': 'Vidéo en pièce jointe',
  'Visitors': 'Visiteurs',
  'When': 'Date et heure',
  'Where': 'Lieu',
  'Who': 'Personne',
  'Witnesses': 'Témoins',
  'Yes': 'Oui',
  'of': 'sur',
  'view in Guardian portal': 'voir dans le portail Guardian',
  '{authority} licence': 'Licence {authority}',
  '{count} days remaining': '{count} jours restants',
  '{count} video attachment (view in Guardian portal)':
    '{count} vidéo en pièce jointe (voir dans le portail Guardian)',
  '{count} video attachments (view in Guardian portal)':
    '{count} vidéos en pièces jointes (voir dans le portail Guardian)',
};
